import { faClock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import RevealDropdown from 'components/base/RevealDropdown';
import { MessageType } from 'providers/SSEProvider';
import { Dropdown } from 'react-bootstrap';
import Avatar from 'components/base/Avatar';
import brain from 'assets/img/th-each-ai/brain.png';

interface NotificationItemTHEachProps {
  notification: MessageType;
  className?: string;
  type: 'dropdownItem' | 'pageItem';
}

const NotificationItemTHEach = ({
  notification,
  className,
  type
}: NotificationItemTHEachProps) => {
  return (
    <div
      className={classNames(
        className,
        'py-3 border-300 notification-card position-relative',
        {
          unread: notification.to_read === 1,
          'px-4 px-lg-6': type === 'pageItem',
          'px-2 px-sm-3': type === 'dropdownItem'
        }
      )}
    >
      <div className="d-flex align-items-center justify-content-between position-relative">
        <div className="d-flex">
          <Avatar
            src={brain}
            size={type === 'pageItem' ? 'xl' : 'm'}
            className="me-3"
          />

          <div
            className={classNames('flex-1', {
              'me-sm-3': type === 'dropdownItem',
              'mt-2 me-2': type === 'pageItem'
            })}
          >

            {type === 'dropdownItem' && (
              <h4 className="fs-9 text-black">{notification.function}</h4>
            )}

            {type === 'pageItem' && (
              <h4 className="fs-7 text-black">{notification.function}</h4>
            )}



            <p className="fs-9 text-1000 mb-2 mb-sm-3">
              <span className="me-1">💬</span>

              {type === 'dropdownItem' && (
                <span>{notification.message}</span>
              )}

              {type === 'pageItem' && (
                <span className="fs-8">{notification.message}</span>
              )}

            </p>
            <p className="text-800 fs-9 mb-0">
              <FontAwesomeIcon icon={faClock} className="me-1" />
              <span className="fw-bold">{notification.time + '  '}</span>
              {notification.date}
            </p>
          </div>
        </div>
        <RevealDropdown
          className={classNames('', {
            'd-none d-sm-block': type === 'dropdownItem'
          })}
          btnClassName="notification-dropdown-toggle"
          dropdownMenuClassName="mt-2"
        >
          <Dropdown.Item>
            Mark as {notification.to_read === 0 ? 'unread' : 'read'}
          </Dropdown.Item>
          <Dropdown.Item>
            Delete
          </Dropdown.Item>
        </RevealDropdown>
      </div>
    </div>
  );
};

export default NotificationItemTHEach;
